import axiosInstance from "./AxiosConfig";

class bannerScheduleScheduleApi {
  async Create(data) {
    try {
      const response = await axiosInstance.post("/bannerSchedule/create", data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async Get() {
    try {
      const response = await axiosInstance.get("/bannerSchedule/get");
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async Delete(id) {
    try {
      const response = await axiosInstance.delete(
        `/bannerSchedule/delete/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async Update(id, data) {
    try {
      const response = await axiosInstance.put(
        `/bannerSchedule/update/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new bannerScheduleScheduleApi();
